import http from 'common-module/src/util/http';

/**
 * 通知上传录制视频
 * @param config
 * @returns {Promise<*>}
 */
export const notifyUploadRecorderVideo = async (data, config) => {
  return http.post('/sys-file/upload/notify-finish-video', data, config);
};

/**
 * 更新录制信息
 * @param fileId
 * @param data
 * @returns {Promise<AxiosResponse<any>|any>}
 */
export const updateRecorder = async (fileId, data) => {
  return http.post('/user-video/update', { fileId, ...data });
};

/**
 * 获取assemblyai NLP语言处理临时token
 * @returns {*}
 */
export const getNLPToken = () => {
  return http.post('/nature-language/fetch-temp-token', { channel: 'ab' });
};

/**
 * 获取阿里云 paraformer 语音转文字处理临时token
 * @returns {*}
 */
export const getParaformerToken = () => {
  return http.post('/nature-language/fetch-temp-token', { channel: 'paraformer' });
};

export const getXFToken = async () => {
  const result = await http.post('/nature-language/fetch-temp-token', { channel: 'xfyun' });
  return {
    appId: result?.app_id,
    ts: result?.ts,
    signature: result?.signa
  };
};

/**
 * 获取视频下载路径
 * @param {Object} params
 * @param {String} params.fileKey
 * @returns
 */
export const getVideoRealPath = (params) => {
  return http.post('/sys-file/download/get-real-path', params);
};


/**
 * 删除录制视频
 * @param id
 * @returns {AxiosPromise | Promise<any>}
 */
export const deleteRecorder = (id) => {
  return http.post('/user-video/delete', { id });
};
